import { makeRequest } from "../utils/api";

export const getPrices = () => {
  return makeRequest("/stripe/prices", "GET");
};

export const getCheckoutUrl =
  (setError) =>
  ({ price_id, promotion_code }) => {
    return makeRequest(
      "/stripe/checkout",
      "POST",
      { price_id, promotion_code },
      false,
      setError
    );
  };

export const cancelSubscription = () => {
  return makeRequest("/stripe/subscriptions/cancel", "DELETE");
};
